module.exports = __webpack_public_path__ + "static/media/28DGC10.a14ed04f.jpg";